export default "__VITE_ASSET__z8_oHjXO__"